export default __webpack_public_path__ + "static/media/emeraldred.21ec5623.mp4";